import { ActionReducer, createReducer, on } from '@ngrx/store';

import {
  addDriversGroup,
  deleteDriversGroup,
  loadDriversGroups,
  loadDriversGroupsFailure,
  loadDriversGroupsSuccess,
  updateDriversGroup,
} from '@store/driversGroups/driversGroups.actions';
import {
  driversGroupsAdapter,
  DriversGroupsState,
  initialDriversGroupsState,
} from '@store/driversGroups/driversGroups.state';

export const driversGroupsReducer: ActionReducer<DriversGroupsState> = createReducer(
  initialDriversGroupsState,
  on(loadDriversGroups, (state) => ({
    ...state,
    loading: true,
    error: undefined,
  })),

  on(loadDriversGroupsSuccess, (state, { list }) =>
    driversGroupsAdapter.setAll(list, {
      ...state,
      loading: false,
    }),
  ),

  on(loadDriversGroupsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(addDriversGroup, (state, { driversGroup }) =>
    driversGroupsAdapter.addOne(driversGroup, state),
  ),
  on(updateDriversGroup, (state, { id, changes }) =>
    driversGroupsAdapter.updateOne({ id: +id, changes }, state),
  ),
  on(deleteDriversGroup, (state, { id }) => driversGroupsAdapter.removeOne(+id, state)),
);
